var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _circle, _rect4, _rect5, _g7, _g8, _g9, _g10, _g11, _g12, _circle2, _rect6, _rect7, _g13, _g14, _g15, _g16, _g17, _g18, _circle3, _circle4, _circle5, _circle6, _g19, _g20, _path, _rect8, _rect9, _path2, _path3, _path4, _rect10, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d208afe9-d246-44b1-9723-4e792280c828",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 904,
    height: 754.77,
    viewBox: "0 0 904 754.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d0586609-2d1f-4894-831f-bc1bf1cfe805",
    x1: 205.5,
    y1: 458.72,
    x2: 205.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc1a1433-8955-4fce-8d84-3a5c46e8d5cb",
    x1: 347.94,
    y1: 120.14,
    x2: 347.94,
    y2: 40.02,
    xlinkHref: "#d0586609-2d1f-4894-831f-bc1bf1cfe805"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6583b9bd-7f21-4a55-b428-c52c7257def0",
    x1: 347.94,
    y1: 269.14,
    x2: 347.94,
    y2: 189.02,
    xlinkHref: "#d0586609-2d1f-4894-831f-bc1bf1cfe805"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d5bb9150-ad00-4040-8c31-39c92932ad3e",
    x1: 347.94,
    y1: 417.14,
    x2: 347.94,
    y2: 337.02,
    xlinkHref: "#d0586609-2d1f-4894-831f-bc1bf1cfe805"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "43ab44a3-beba-4304-ae82-955b08a7fed3",
    x1: 660.91,
    y1: 754.77,
    x2: 660.91,
    y2: 737.77,
    xlinkHref: "#d0586609-2d1f-4894-831f-bc1bf1cfe805"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e180fe82-c096-4b7f-a7fc-e0d67eafb4b3",
    x1: 810,
    y1: 732,
    x2: 810,
    y2: 417,
    xlinkHref: "#d0586609-2d1f-4894-831f-bc1bf1cfe805"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 411,
    height: 458.72,
    fill: "url(#d0586609-2d1f-4894-831f-bc1bf1cfe805)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.79,
    y: 306.27,
    width: 397.41,
    height: 142.46,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.41,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.22,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.62,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.02,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.42,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.83,
    y: 340.06,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 376.09,
    r: 37.16,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.79,
    y: 158.26,
    width: 397.41,
    height: 142.46,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.41,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.22,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.62,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.02,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.42,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.83,
    y: 192.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 228.09,
    r: 37.16,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.79,
    y: 10.25,
    width: 397.41,
    height: 142.46,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.41,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.22,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.62,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.02,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.42,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.83,
    y: 44.05,
    width: 15.4,
    height: 73,
    fill: "#64ffda"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 80.08,
    r: 40.06,
    fill: "url(#dc1a1433-8955-4fce-8d84-3a5c46e8d5cb)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 229.08,
    r: 40.06,
    fill: "url(#6583b9bd-7f21-4a55-b428-c52c7257def0)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 377.08,
    r: 40.06,
    fill: "url(#d5bb9150-ad00-4040-8c31-39c92932ad3e)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.94,
    cy: 80.08,
    r: 37.16,
    fill: "#6c63ff"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 461,
    y1: 158.67,
    x2: 467,
    y2: 158.67,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.38,
    y1: 158.67,
    x2: 667.31,
    y2: 158.67,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    strokeDasharray: "12.52 33.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "684 158.67 690 158.67 690 164.67",
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690,
    y1: 196.48,
    x2: 690,
    y2: 311.77,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    strokeDasharray: "11.93 31.8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690,
    y1: 327.67,
    x2: 690,
    y2: 333.67,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 367.58,
    y1: 611.67,
    x2: 361.58,
    y2: 611.64,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.2,
    y1: 611.48,
    x2: 161.28,
    y2: 610.68,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    strokeDasharray: "12.52 33.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "144.58 610.61 138.58 610.58 138.62 604.58",
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.82,
    y1: 573.79,
    x2: 139.28,
    y2: 504.52,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    strokeDasharray: "11.55 30.79"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.38,
    y1: 489.12,
    x2: 139.42,
    y2: 483.12,
    fill: "none",
    stroke: "#6c63ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M869.21,703.08s11.92,80.48,82.27,107.31h-285c70.35-26.83,82.27-107.31,82.27-107.31Z",
    transform: "translate(-148 -72.62)",
    fill: "#e0e0e0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 517.09,
    y: 737.77,
    width: 287.65,
    height: 17,
    fill: "url(#43ab44a3-beba-4304-ae82-955b08a7fed3)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 518.52,
    y: 737.77,
    width: 284.96,
    height: 13.12,
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.25,417H578.75A10.75,10.75,0,0,0,568,427.75V719.14A12.86,12.86,0,0,0,580.86,732h458.28A12.86,12.86,0,0,0,1052,719.14V427.75A10.75,10.75,0,0,0,1041.25,417Z",
    transform: "translate(-148 -72.62)",
    fill: "url(#e180fe82-c096-4b7f-a7fc-e0d67eafb4b3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M436.57,348.78H885.43a10.75,10.75,0,0,1,10.75,10.75V609a0,0,0,0,1,0,0H425.82a0,0,0,0,1,0,0V359.54A10.75,10.75,0,0,1,436.57,348.78Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.32,724.54H586.68a12.86,12.86,0,0,1-12.86-12.86V681.62h470.36v30.06A12.86,12.86,0,0,1,1031.32,724.54Z",
    transform: "translate(-148 -72.62)",
    fill: "#f5f5f5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 449.07,
    y: 369.86,
    width: 425.65,
    height: 210.06,
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "465.91 383.8 874.99 383.8 874.99 369.79 449.34 369.79 449.34 579.85 465.91 579.85 465.91 383.8",
    fill: "#fff",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.f33fa5667ac247acda6aec53e61e5e8f.svg";
export { ForwardRef as ReactComponent };